import { render, staticRenderFns } from "./RepairExtensionCard.vue?vue&type=template&id=f13be860"
import script from "./RepairExtensionCard.vue?vue&type=script&lang=js"
export * from "./RepairExtensionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports